export default __webpack_public_path__ + "static/media/bitrix-icon.e25d161f.png";